import React, {useEffect, useState} from "react";
import "./orderCM.style.scss";
import {Button, Card, Dropdown, Input, Radio, Menu, Typography} from "antd";
import {get, post, responseValidator, SITEURL} from "../../../../../api";
import Loading from "../../../../../loading/loading.index";
import DownOutlined from "@ant-design/icons/lib/icons/DownOutlined";
import {toast} from "react-toastify";
import {ToIranCurrency} from "../../../../../util/string";

export default function OrderS1CM() {
    const [payment, setPayment] = useState(null);
    const [allPayment, setALlPayment] = useState([]);
    const [allCards, setAllCards] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null);
    const [allNetworks, setAllNetworks] = useState([]);
    const [networkSelected, setNetworkSelected] = useState();
    const [depositMethod, setDepositMethod] = useState({
        title: "حساب",
        payload: 1
    });
    const [loading, setLoading] = useState(true);
    const [orderDetail, setOrderDetail] = useState(null);
    const [isMemo, setIsMemo] = useState(false);
    const {Text} = Typography;
    const [wallet, setWallet] = useState(undefined);
    const [memo, setMemo] = useState(null);
    const [walletBool, setWalletBool] = useState(undefined);
    const [memoBool, setMemoBool] = useState(undefined);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [isAllDisable, setIsAllDisable] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [timeRemaining, setTimeRemaining] = useState(30);
    const [timeRemaining2, setTimeRemaining2] = useState(300);
    const [paymentURL, setPaymentURL] = useState(null);
    const [txID, setTxID] = useState(undefined);
    const [address, setAddress] = useState(undefined);
    const [qrCode, setQrCode] = useState(undefined);

    function s_to_mmss(time = 0) {
        const second = time % 60;
        const min = Math.floor(time / 60);
        return (
            (min < 10 ? "0" + min : min) +
            ":" +
            (second < 10 ? "0" + second : second)
        );
    }

    function counter(value) {
        setTimeRemaining(value);
        if (value > 0) {
            setTimeRemaining(value);
            setTimeout(() => {
                counter(value - 1);
            }, 1000);
        } else {
            setTimeRemaining(30);
        }
    }

    function counter2(value) {
        setTimeRemaining2(value);
        if (value > 0) {
            setTimeRemaining2(value);
            setTimeout(() => {
                counter2(value - 1);
            }, 1000);
        } else {
            setTimeRemaining2(300);
        }
    }

    useEffect(() => {
        if (isAllDisable) counter(30);
        else counter2(300)
    }, [isAllDisable]);

    function getNetworks(order) {
        return new Promise(resolve => {
            get(`/Market/Crypto/${order}/Networks`).then(res => {
                resolve(true);
                if (responseValidator(res.status)) {
                    //   console.log((res.data.data.networks)[0])
                    setNetworkSelected(
                        res.data.data.networks.find(
                            item => order==='USDT'? item.network==='TRX':item.isDefault === true
                        )
                    );
                    setAllNetworks(res.data.data.networks);
                } else toast.error(res.data.message);
            });
        });
    }

    function getOrder() {
        setPageLoading(true);
        return new Promise(resolve => {
            get(`/Order/` + localStorage.getItem("order") + `/Details`).then(
                res => {
                    setPageLoading(false);
                    if (responseValidator(res.status)) {
                        setOrderDetail(res.data.data);
                        resolve(res.data.data.depositTransaction.market);
                    } else {
                        window.location.replace("/userpanel/order/");
                        toast.error(res.data.message);
                    }
                }
            );
        });
    }

    async function getDetails() {
        const order = await getOrder();
        const networks = await getNetworks(order.symbol);
        console.log(order);
        setLoading(false);
    }

    useEffect(() => {
        getDetails();
    }, []);

    useEffect(() => {
        if (networkSelected) {
            setPageLoading(true);
            get(
                `/Wallet/${orderDetail.depositTransaction.market.symbol}/${networkSelected.network}/SytemWallet`
            ).then(res => {
                setPageLoading(false);
                if (responseValidator(res.status)) {
                    console.log(res);
                    setAddress(res.data.data.address);
                    setMemo(res.data.data.memoTag);
                    setQrCode(res.data.data.qrCode);
                } else toast.error(res.data.message);
            });
        }
    }, [networkSelected]);

    useEffect(() => {
        if (networkSelected) {
            if (memo === "") setMemoBool(undefined);
            else {
                console.log(networkSelected.memoRegex);
                const regex = new RegExp(networkSelected.memoRegex);
                console.log(regex);
                console.log(regex.test(memo));
                setMemoBool(regex.test(memo));
            }
        }
    }, [memo]);

    function submitHandler() {
        if (!isAllDisable) {
            setSubmitLoading(true);
            let body = {
                trackingCode: localStorage.getItem("order"),
                txid: txID
            };

            if (isMemo) body.destinationMemoTag = memo;
            post("/Order/Deposit/Crypto", body).then(res => {
                if (responseValidator(res.status)) {
                    const body2 = {
                        trackingCode: localStorage.getItem("order"),
                        destinationMoneyAccount: wallet
                    };
                    if (depositMethod.payload === 1)
                        body2.CreateVoucher = false;
                    else body2.CreateVoucher = true;
                    post("/Order/Crypto/X", body2).then(res => {
                        setSubmitLoading(false);
                        if (responseValidator(res.status)) {
                            window.location.replace(
                                `/userpanel/order/verify/${orderDetail.trackingCode}?waiting=true&amount=4000000&refnum=rWz2B7qO&state=SUCCESSFUL&payment`
                            );
                        } else toast.error(res.data.message);
                    });
                    //setIsAllDisable(true)
                    //setPaymentURL(res.data.data.callbackUrl)
                    //getOrder()
                    // toast.success('اطلاعات ثبت شد . برای ادامه ی کار ۱۰ دقیقه فرصت دارید تا به درگاه پرداخت از طریق دکمه ی زیر انتقال یابید', {autoClose: 10000,})
                } else toast.error(res.data.message);
            });
        } else {
            console.log(paymentURL);
            window.location.replace(paymentURL);
        }
    }

    useEffect(() => {

        if (wallet === "" || wallet === undefined) setWalletBool(undefined);
        else {
            const regex = new RegExp('^U{1}\\d{8}$');
            setWalletBool(regex.test(wallet));
        }

    }, [wallet]);

    if (!networkSelected || pageLoading) return <Loading/>;
    else
        return (
            <div className="order-first-step-c-m-page">
                <h3>{isAllDisable ? 'فاکتور نهایی' : 'پیش فاکتور'}</h3>
                <div className="order-first-step-irt-c-page-content">
                    {loading && <Loading/>}
                    <Card title="ارز مبدا">
                        <div className="item">
                            <p>نام : </p>
                            <h5>
                                {
                                    orderDetail.depositTransaction.market
                                        .description
                                }
                            </h5>
                            <img alt='crypto'
                                 style={{width: '35px', height: '35px', borderRadius: '100%', marginRight: '10px'}}
                                 src={
                                     SITEURL + orderDetail.depositTransaction.market
                                         .icon
                                 }/>
                        </div>
                        <div className="item">
                            <p>مقدار : </p>
                            <h5>
                                {orderDetail.depositTransaction.amount} واحد
                            </h5>
                        </div>
                        <div className="item">
                            <p>کارمزد تبدیل: </p>
                            <h5>
                                {ToIranCurrency(orderDetail.depositTransaction.rateCommssion)}
                                {" "}
                                تومان
                            </h5>
                        </div>
                        <div className="card network">
                            <p style={{marginLeft: 0}}>
                                شبکه مورد نظر را انتخاب نمایید :{" "}
                            </p>
                            {allNetworks.length !== 0 && (
                                <Dropdown
                                    disabled={isAllDisable}
                                    overlay={
                                        <Menu>
                                            {allNetworks.map(item => (
                                                <Menu.Item
                                                    onClick={() =>
                                                        setNetworkSelected(item)
                                                    }
                                                    key={item.name}
                                                >
                                                    <div className="one-card-drop-down-selected network">
                                                        <h4>{item.name}</h4>
                                                    </div>
                                                </Menu.Item>
                                            ))}
                                        </Menu>
                                    }
                                    trigger={["click"]}
                                >
                                    <div className="one-card-drop-down-selected payment">
                                        <h4>{networkSelected.name}</h4>
                                        <DownOutlined/>
                                    </div>
                                </Dropdown>
                            )}
                        </div>
                        <p className="item">آدرس : {address} ‌<i style={{cursor: 'pointer'}} onClick={() => {
                            navigator.clipboard.writeText(
                                address
                            );
                            toast.success("کپی شد");
                        }} className="far fa-copy"/>‌</p>
                        {memo && (
                            <p
                                className="item"
                                style={{
                                    width: "fit-content",
                                    direction: "ltr"
                                }}
                            ><i style={{cursor: 'pointer', marginRight: '4px'}} onClick={() => {
                                navigator.clipboard.writeText(
                                    memo
                                );
                                toast.success("کپی شد");
                            }} className="far fa-copy"/>
                                {memo} : Memo{" "}
                            </p>
                        )}
                        <div className="qrCode">
                            <img
                                alt="qr-code"
                                src={`data:image;base64,` + qrCode}
                            />
                        </div>
                    </Card>
                    <Card title="ارز مقصد">
                        <div className="item">
                            <p>نام :‌ </p>
                            <h5>
                                {
                                    orderDetail.withdrawTransaction.market
                                        .description
                                }
                            </h5>
                            <img alt='crypto'
                                 style={{width: '35px', height: '35px', borderRadius: '100%', marginRight: '10px'}}
                                 src={
                                     SITEURL + orderDetail.withdrawTransaction.market
                                         .icon
                                 }/>
                        </div>
                        <div className="item">
                            <p>مقدار دریافتی : </p>
                            <h5>
                                {orderDetail.withdrawTransaction.amount} واحد
                            </h5>
                        </div>
                        <div className="card">
                            <p style={{marginLeft: "4px"}}>
                                روش دریافت خود را انتخاب کنید :{" "}
                            </p>
                            <Dropdown
                                disabled={isAllDisable}
                                overlay={
                                    <Menu>
                                        <Menu.Item
                                            onClick={() =>
                                                setDepositMethod({
                                                    title: "حساب",
                                                    payload: 1
                                                })
                                            }
                                        >
                                            <div className="one-card-drop-down-selected ">
                                                <h4>حساب</h4>
                                            </div>
                                        </Menu.Item>
                                        <Menu.Item
                                            onClick={() =>
                                                setDepositMethod({
                                                    title: "ووچر",
                                                    payload: 2
                                                })
                                            }
                                        >
                                            <div className="one-card-drop-down-selected ">
                                                <h4>ووچر</h4>
                                            </div>
                                        </Menu.Item>
                                    </Menu>
                                }
                                trigger={["click"]}
                            >
                                <div className="one-card-drop-down-selected">
                                    <h4 style={{margin: "0 0 0 8px"}}>
                                        {depositMethod.title}
                                    </h4>
                                    <DownOutlined/>
                                </div>
                            </Dropdown>
                        </div>
                    </Card>
                </div>
                <Card className="my-input-card">
                  <div className="right">
                        <div className="my-inputs">
                            <p style={{minWidth: "0", marginLeft: "12px"}}>
                                TxID :{" "}
                            </p>
                            <Input
                                disabled={isAllDisable}
                                value={txID}
                                onChange={e => setTxID(e.target.value)}
                                placeholder="TxID"
                            />
                        </div>
                        {depositMethod.payload === 1 &&   <div className="my-inputs">
                            <p style={{marginLeft: "12px"}}>
                                شماره حساب  :{" "}
                            </p>
                            <Input
                                disabled={isAllDisable}
                                value={wallet}
                                onChange={e => setWallet(e.target.value)}
                                placeholder="U26009786"
                            />
                            {walletBool !== undefined ? (
                                walletBool === false ? (
                                    <Text className="error-text" type="danger">
                                        نا معتبر
                                    </Text>
                                ) : (
                                    <Text className="error-text" type="success">
                                        معتبر
                                    </Text>
                                )
                            ) : (
                                <div className="error-text"/>
                            )}
                        </div>}
                    </div>

                    <div className="my-btn">
                        <Button
                            style={{left: '150px'}}
                            onClick={() => window.location.href = '/userpanel/order'}
                            type={"default"}
                        >
                            لغو
                        </Button>
                        <Button
                            disabled={!txID && !isAllDisable && depositMethod.payload === 1}
                            onClick={submitHandler}
                            loading={submitLoading}
                            type={"primary"}
                        >
                            {isAllDisable ? "انتقال به درگاه پرداخت" : "ادامه"}
                        </Button>
                        {isAllDisable ? (
                            <Text type="warning counter">
                                {" "}
                                زمان باقی مانده : {s_to_mmss(
                                timeRemaining
                            )}{" "}
                                دقیقه
                            </Text>
                        ) : <Text type="warning counter">
                            {" "}
                            زمان باقی مانده : {s_to_mmss(
                            timeRemaining2
                        )}{" "}
                            دقیقه
                        </Text>}
                    </div>
                </Card>
            </div>
        );
}
